<template>
  <div class="wrap">
      <h3>Application:</h3>
      <AppLogComponent 
        @update:logAction="logAction" 
        :appLog="appLog"
      />
      <h3>Worker</h3>
      <div v-for="(worker, index) in wrkLog" :key="index">
        <h4>Worker {{ worker.workerID }}</h4>
        <WorkerLogComponent
          @update:logAction="logAction"
          :workerID="worker.workerID*1"
          :workerData="worker"
        />
      </div>      
  </div>
</template>

<script>
// import { computed, onBeforeMount, onErrorCaptured } from 'vue'
import { computed, onMounted, onErrorCaptured } from 'vue';
import { useStore } from 'vuex';
import AppLogComponent from './AppLogComponent.vue';
import WorkerLogComponent from './WorkerLogComponent.vue';

export default {
  name: 'LogComponent',
  components: {
    AppLogComponent,
    WorkerLogComponent
  },

  setup() {
    const store = useStore()

    // Computed properties - convert from computed object with mapState
    const appLog = computed(() => store.state.dash.appLog)
    const wrkLog = computed(() => store.state.dash.wrkLog)
    const dashID = computed(() => store.state.dash.dashID)
    const trc = computed(() => 0) // Placeholder since table.rows.length is not available in this component

    // Methods - convert from methods object
    const fetchLogs = () => store.dispatch('dash/fetchLogs')
    const adminCommand = (payload) => store.dispatch('dash/adminCommand', payload)
    //const setSearchSPZ = (val) => store.commit('dash/setSearchSPZ', val)

    const logAction = (evt) => {
        console.log('Received event:', evt)
        let payload = {}
        if(evt.id)       payload.id = evt.id
        if(evt.workerID) payload.workerID = evt.workerID
        if(!evt.workerID) payload = null
        adminCommand({ jobID: evt.jobID, command: evt.action, payload })
     // app: {jobID: 111, action: 'WIP'} // no worker data
     // wrk: {jobID: 111, action: 'WIP', workerID: 2}
     // wrk: {jobID: 111, action: 'DELWRKLOG', workerID: 2, id: 8871}
    }

    // Error handling - convert errorCaptured to onErrorCaptured
    onErrorCaptured((err, instance, msg) => {
      console.log('errorCaptured', err, msg)
    })

    onMounted(async () => {
      try {
        await fetchLogs()
        //console.log(appLog.value?.head)
        //console.table(appLog.value?.logs)
        //console.log(wrkLog.value?.[0]?.head)
        //console.table(wrkLog.value?.[0]?.logs)
      } catch (error) {
        console.error("Error fetching logs:", error)
      }
    })

    return {
      appLog,
      wrkLog,
      dashID,
      trc,
      logAction
    }
  }
}
</script>


<style scoped>

body {
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    margin: 0;
    padding: 0;
    color: white;
    background-color: #1e1e1e;
}
.wrap {
    padding: 5px;
}
::v-deep(.vtl-table td) { padding: 3px; }

::v-deep(.vtl-card) {
  background-color: #333333;  
}
::v-deep(.vtl-table tr) {
  border: none;
  color: white;
}


</style>